import React from 'react'
import { Paper, Stack, Table, TableBody, TableCell, TableContainer, TableRow, Typography } from '@mui/material'
import { useGlobalState } from 'state'
import { QuestionFrameContext } from 'components/questions'


export const BuildingHeightFromFlood = () => {
  const state = useGlobalState()
  const q = React.useContext(QuestionFrameContext)

  const lineHeights = React.useMemo((): [string, string, string] => {

    // 外水氾濫、内水氾濫のtp値を取得
    const riskQ = q === 8 ? state.app.getAnswer(2, 1) : state.app.getAnswer(4, 1)
    let risk_tp = null
    if (riskQ !== null && isFinite(Number(riskQ.value.tpValue))) {
      risk_tp = parseFloat(Number(riskQ.value.tpValue).toFixed(2))
    }

    const q5_1 = state.app.getAnswer(5, 1)
    let q5_1_tp = null
    if (q5_1 !== null && isFinite(Number(q5_1.value))) {
      q5_1_tp = parseFloat(Number(q5_1.value).toFixed(2))
    }

    const q5_2 = state.app.getAnswer(5, 2)
    let q5_2_tp = null
    if (q5_2 !== null && isFinite(Number(q5_2.value))) {
      q5_2_tp = parseFloat(Number(q5_2.value).toFixed(2))
    }

    const q6_1 = state.app.getAnswer(6, 1)
    const is_line_no = q6_1 !== null && q6_1.value === 'いいえ'

    const q6_2 = state.app.getAnswer(6, 2)
    let q6_2_value = null
    if (q6_2 !== null && isFinite(Number(q6_2.value.text))) {
      q6_2_value = parseFloat(Number(q6_2.value.text).toFixed(2))
    }

    let gl = '-'
    if (risk_tp !== null && q5_1_tp !== null) {
      gl = ((q5_1_tp * 100 - risk_tp * 100) / 100).toFixed(2)
    }

    let bo = '-'
    if (risk_tp !== null && q5_1_tp !== null && q5_2_tp !== null) {
      bo = ((q5_1_tp * 100 + q5_2_tp * 100 - risk_tp * 100) / 100).toFixed(2)
    }

    let line = '-'
    if (is_line_no !== true && q6_2 !== null && q6_2_value !== null && risk_tp !== null) {
      if (q6_2.value.radio === 'tp') {
        line = ((q6_2_value * 100 - risk_tp * 100) / 100).toFixed(2)
      } else if (q6_2.value.radio === 'aperture' && bo !== '-' && q5_1_tp !== null && q5_2_tp !== null) {
        line = ((q6_2_value * 100 + q5_1_tp * 100 + q5_2_tp * 100 - risk_tp * 100) / 100).toFixed(2)
      }
    }

    const convert = (value: string) => {
      if (value === '-') {
        return value
      }
      return Number(value) < 0 ? `${value}m` : `+${value}m`
    }

    return [
      convert(gl),
      convert(bo),
      convert(line)
    ]
  }, [state.app.answers])

  return (
    <Stack mb={4} direction={'row'} spacing={2} alignItems={'flex-end'}>

      <Stack direction={'column'}>
        <Typography variant='caption'>参考）最大浸水位から建物各部の高さ</Typography>
        <TableContainer component={Paper} variant='outlined'>
          <Table size="small" sx={{minWidth: 380}}>
            <TableBody>
              <TableRow>
                <TableCell padding='none' align='center' height={30}>基準点（GL=±0）</TableCell>
                <TableCell width={110} padding='none' align='center'>開口部最下端</TableCell>
                <TableCell width={110} padding='none' align='center'>水防ライン</TableCell>
              </TableRow>
            </TableBody>
            <TableBody>
              <TableRow>
                <TableCell padding='none' align='center' height={30}>{ lineHeights[0] }</TableCell>
                <TableCell padding='none' align='center'>{ lineHeights[1] }</TableCell>
                <TableCell padding='none' align='center'>{ lineHeights[2] }</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Stack>

      <Stack>
        <Typography variant='caption'>※ 当該部が最大浸水位より上の場合はプラス、下の場合はマイナスとして表示</Typography>
        <Typography variant='caption'>※ 設備機器単体の水防ラインがある場合、又は基礎で嵩上げしている場合等は、左記によらず、各々の水防ラインや嵩上げ高さ等から下記の評価を行ってください。</Typography>
      </Stack>
    </Stack>
  )
}
